import { Centre } from "app/shared/model";

export interface CurrencyRefDto {
  id: string;
  isoCode: string;
  name: string;
  symbol: string;
}


export const normIso = (v: unknown): string =>
  String(v ?? "")
    .trim()
    .toUpperCase();

export const getCentreCurrencyIso = (
  centres: Centre[],
  selectedCentreCode?: string
): string => {
  const centre = centres.find((c) => (c as any).code === selectedCentreCode);
  return String((centre as any)?.currencyCode ?? "").trim();
};

export const getFeeCurrencyIso = (
  fee: { currencyIsoCode?: string },
  fallbackIso: string
): string => normIso(fee.currencyIsoCode) || normIso(fallbackIso) || "EUR";

export const normalizeCurrencies = (res: any): CurrencyRefDto[] => {
  const arr = Array.isArray(res)
    ? res
    : Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res?.currencies)
    ? res.currencies
    : Array.isArray(res?.items)
    ? res.items
    : [];

  const mapped = (arr ?? [])
    .map((x: any) => {
      const iso = normIso(
        x?.isoCode ?? x?.code ?? x?.currencyIsoCode ?? x?.IsoCode ?? x?.Code
      );
      if (!iso) return null;

      return {
        id: String(x?.id ?? x?.Id ?? iso),
        isoCode: iso,
        name: String(
          x?.name ?? x?.Name ?? x?.displayName ?? x?.DisplayName ?? iso
        ),
        symbol: String(x?.symbol ?? x?.Symbol ?? ""),
      } as CurrencyRefDto;
    })
    .filter(Boolean) as CurrencyRefDto[];

  return [...new Map(mapped.map((c) => [c.isoCode, c])).values()].sort((a, b) =>
    a.isoCode.localeCompare(b.isoCode)
  );
};
